import React from 'react';
import { useTheme } from '@mui/material/styles';

export default function EditedTag({ style = {} }) {
  const theme = useTheme();
  return (
    <em style={{ color: (theme.vars || theme).palette.text.secondary, ...style, fontSize:"0.8em" }}>
      (Edited)
    </em>
  );
}

